import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import MacroFlare from "@/components/MacroFlare";
import Dashboard from "@/components/Dashboard";
import LoginScreen from "@/components/LoginScreen";
import { getToken, removeToken } from "@/lib/tokenStorage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Axios interceptor: attach auth token
axios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Axios interceptor: handle 401 (session expired)
// Exclude /auth/ and /ops/auth routes from auto-logout
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    const isAuthRoute = url.includes('/auth/') || url.includes('/ops/auth') || url.includes('/ops/change-password');
    if (error.response?.status === 401 && !isAuthRoute) {
      removeToken();
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (token) {
      axios.get(`${BACKEND_URL}/api/v1/sentinel/auth/verify`)
        .then(() => setAuthenticated(true))
        .catch(() => {
          removeToken();
          setAuthenticated(false);
        })
        .finally(() => setChecking(false));
    } else {
      setChecking(false);
    }
  }, []);

  if (checking) {
    return (
      <div className="App" style={{
        backgroundColor: '#0d1117',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 40,
            height: 40,
            border: '2px solid #30363d',
            borderTopColor: '#ff6b2b',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
            margin: '0 auto 16px',
          }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  if (!authenticated) {
    return (
      <div className="App cw-noise">
        <LoginScreen onAuthenticated={() => setAuthenticated(true)} />
      </div>
    );
  }

  return (
    <div className="App cw-noise">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MacroFlare />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
